import axios from 'axios';
import config from '../../Config';

const instance = axios.create({
  baseURL: config.API_BASE_URL
});

/**
 * Switches the BFF base URL used by every request made through the shared axios instance.
 * Used to route traffic between the Europa and Azure (Metis) dxp-bettacart-bff deployments.
 */
export const setApiBaseUrl = (baseUrl: string): void => {
  instance.defaults.baseURL = baseUrl;
};

export default instance;
